module.exports = __webpack_public_path__ + "img/4.150cff7e.png";